<template>
	<div class="row-fluid">
		<div class="span12 text-left" style="margin-bottom: 20px;">
			<div class="bg_voice">
				<img style="width: 100%; height: 150px;border-radius:10px;" src="../../../assets/logo.png" />
			</div>
		</div>

		<div class="app-container">
			<div class="the-container">
				<el-tabs v-model="usable" :tab-position="tabPosition" @tab-click="handleClick">
					<el-tab-pane v-for="(tab,index) in tabs" :key="index" :name="tab.name" :label="tab.label">
						<div v-show="usable==='1'">
							
								
							<div class="span12" style="margin-top: 5px;margin-bottom: 20px;"
								v-for="(item, index) in [2,3,4,4,4,4,3,4,5,6,7]">
								<!--t_10-->
								<div class="row">
									<div class="col-8">
										<h4>fdsafsdafdsafsdafsda</h4>
										<h6>fdsafsdafdsafsdafsda</h6>
									</div>
									<div class="col-4">
										<img style="width: 100%; height: 80px;border-radius:5%;" src="../../../assets/logo.png" />
									</div>
								</div>
								<hr />
							</div>
						</div>
						<div v-show="usable==='2'">
							<h1>配置管理</h1>
						</div>
						<div v-show="usable==='3'">
							<h1>角色管理</h1>
						</div>
						<div v-show="usable==='4'">
							<h1>部门管理</h1>
						</div>
					</el-tab-pane>
				</el-tabs>
			</div>
		</div>
	
	
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tabPosition: 'top',
				usable: '1',
				tabs: [{
						name: '1',
						label: '用户管理'
					},
					{
						name: '2',
						label: '配置管理'
					},
					{
						name: '3',
						label: '角色管理'
					},
					{
						name: '4',
						label: '角色管理'
					}
				]
			}
		},
		methods: {
			handleClick(tab) {
				console.log(tab)
			}
		}
	}
</script>

<style>
	.t_b .col-3 .b_t_5 {
		margin-top: 5px;
	}

	.t_b .col-3 {
		margin-top: 10px;
	}

	.el-tabs__item{
	font-size:16px !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/views/jjgh/add_users_d.vue